import httpUtil from "../utils/http.util";

class LangService {
  async getAllLanguages() {
    return await httpUtil.get("lang/findAll");
  }
}

export default new LangService();
